import { render } from "./GraphicsTemplate.vue?vue&type=template&id=e68547be&scoped=true"
import script from "./GraphicsTemplate.vue?vue&type=script&lang=js"
export * from "./GraphicsTemplate.vue?vue&type=script&lang=js"

import "./GraphicsTemplate.vue?vue&type=style&index=0&id=e68547be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e68547be"]])

export default __exports__